import { render } from "./SPRINT_RISK_ALERT.vue?vue&type=template&id=46fd03f0&ts=true"
import script from "./SPRINT_RISK_ALERT.vue?vue&type=script&lang=ts"
export * from "./SPRINT_RISK_ALERT.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__